import {
  ArrowLongLeftIcon as ArrowLongLeftIconMicro,
  ArrowLongRightIcon as ArrowLongRightIconMicro,
  ArrowRightIcon as ArrowRightIconMicro,
  BanknotesIcon as BanknotesIconMicro,
  BuildingOfficeIcon as BuildingOfficeIconMicro,
  CheckCircleIcon as CheckCircleIconMicro,
  CheckIcon as CheckIconMicro,
  ChevronDownIcon as ChevronDownIconMicro,
  CreditCardIcon as CreditCardIconMicro,
  ExclamationCircleIcon as ExclamationCircleIconMicro,
  ExclamationTriangleIcon as ExclamationTriangleIconMicro,
  HomeIcon as HomeIconMicro,
  QrCodeIcon as QrCodeIconMicro,
  Square2StackIcon as Square2StackIconMicro,
  UserIcon as UserIconMicro,
  XCircleIcon as XCircleIconMicro,
} from "@heroicons/react/16/solid";

import {
  ArrowLongLeftIcon as ArrowLongLeftIconMini,
  ArrowLongRightIcon as ArrowLongRightIconMini,
  ArrowRightIcon as ArrowRightIconMini,
  BanknotesIcon as BanknotesIconMini,
  BuildingOfficeIcon as BuildingOfficeIconMini,
  CheckCircleIcon as CheckCircleIconMini,
  CheckIcon as CheckIconMini,
  ChevronDownIcon as ChevronDownIconMini,
  CreditCardIcon as CreditCardIconMini,
  ExclamationCircleIcon as ExclamationCircleIconMini,
  ExclamationTriangleIcon as ExclamationTriangleIconMini,
  HomeIcon as HomeIconMini,
  QrCodeIcon as QrCodeIconMini,
  Square2StackIcon as Square2StackIconMini,
  UserIcon as UserIconMini,
  XCircleIcon as XCircleIconMini,
} from "@heroicons/react/20/solid";

import {
  ArrowLongLeftIcon as ArrowLongLeftIconOutline,
  ArrowLongRightIcon as ArrowLongRightIconOutline,
  ArrowRightIcon as ArrowRightIconOutline,
  BanknotesIcon as BanknotesIconOutline,
  BuildingOfficeIcon as BuildingOfficeIconOutline,
  CheckCircleIcon as CheckCircleIconOutline,
  CheckIcon as CheckIconOutline,
  ChevronDownIcon as ChevronDownIconOutline,
  CreditCardIcon as CreditCardIconOutline,
  ExclamationCircleIcon as ExclamationCircleIconOutline,
  ExclamationTriangleIcon as ExclamationTriangleIconOutline,
  HomeIcon as HomeIconOutline,
  QrCodeIcon as QrCodeIconOutline,
  Square2StackIcon as Square2StackIconOutline,
  UserIcon as UserIconOutline,
  XCircleIcon as XCircleIconOutline,
} from "@heroicons/react/24/outline";

import {
  ArrowLongLeftIcon as ArrowLongLeftIconSolid,
  ArrowLongRightIcon as ArrowLongRightIconSolid,
  ArrowRightIcon as ArrowRightIconSolid,
  BanknotesIcon as BanknotesIconSolid,
  BuildingOfficeIcon as BuildingOfficeIconSolid,
  CheckCircleIcon as CheckCircleIconSolid,
  CheckIcon as CheckIconSolid,
  ChevronDownIcon as ChevronDownIconSolid,
  CreditCardIcon as CreditCardIconSolid,
  ExclamationCircleIcon as ExclamationCircleIconSolid,
  ExclamationTriangleIcon as ExclamationTriangleIconSolid,
  HomeIcon as HomeIconSolid,
  QrCodeIcon as QrCodeIconSolid,
  Square2StackIcon as Square2StackIconSolid,
  UserIcon as UserIconSolid,
  XCircleIcon as XCircleIconSolid,
} from "@heroicons/react/24/solid";

import type { SVGProps } from "react";

export type HeroIconName =
  | "arrow-long-left"
  | "arrow-long-right"
  | "arrow-right"
  | "check"
  | "check-circle"
  | "x-circle"
  | "credit-card"
  | "exclamation-circle"
  | "exclamation-triangle"
  | "qr-code"
  | "banknotes"
  | "chevron-down"
  | "square-2-stack"
  | "home"
  | "building-office"
  | "user";
type HeroIconStyle = "outline" | "solid" | "mini" | "micro";

export type HeroIconProps = {
  name: HeroIconName;
  iconStyle?: HeroIconStyle;
} & SVGProps<SVGSVGElement>;

export const HeroIcon = ({
  name,
  iconStyle = "outline",
  ...props
}: HeroIconProps) => {
  const renderIcon = () => {
    switch (name) {
      case "arrow-long-left":
        if (iconStyle === "solid") return <ArrowLongLeftIconSolid {...props} />;
        if (iconStyle === "mini") return <ArrowLongLeftIconMini {...props} />;
        if (iconStyle === "micro") return <ArrowLongLeftIconMicro {...props} />;
        return <ArrowLongLeftIconOutline {...props} />;
      case "arrow-long-right":
        if (iconStyle === "solid")
          return <ArrowLongRightIconSolid {...props} />;
        if (iconStyle === "mini") return <ArrowLongRightIconMini {...props} />;
        if (iconStyle === "micro")
          return <ArrowLongRightIconMicro {...props} />;
        return <ArrowLongRightIconOutline {...props} />;
      case "arrow-right":
        if (iconStyle === "solid") return <ArrowRightIconSolid {...props} />;
        if (iconStyle === "mini") return <ArrowRightIconMini {...props} />;
        if (iconStyle === "micro") return <ArrowRightIconMicro {...props} />;
        return <ArrowRightIconOutline {...props} />;
      case "check":
        if (iconStyle === "solid") return <CheckIconSolid {...props} />;
        if (iconStyle === "mini") return <CheckIconMini {...props} />;
        if (iconStyle === "micro") return <CheckIconMicro {...props} />;
        return <CheckIconOutline {...props} />;
      case "check-circle":
        if (iconStyle === "solid") return <CheckCircleIconSolid {...props} />;
        if (iconStyle === "mini") return <CheckCircleIconMini {...props} />;
        if (iconStyle === "micro") return <CheckCircleIconMicro {...props} />;
        return <CheckCircleIconOutline {...props} />;
      case "x-circle":
        if (iconStyle === "solid") return <XCircleIconSolid {...props} />;
        if (iconStyle === "mini") return <XCircleIconMini {...props} />;
        if (iconStyle === "micro") return <XCircleIconMicro {...props} />;
        return <XCircleIconOutline {...props} />;
      case "credit-card":
        if (iconStyle === "solid") return <CreditCardIconSolid {...props} />;
        if (iconStyle === "mini") return <CreditCardIconMini {...props} />;
        if (iconStyle === "micro") return <CreditCardIconMicro {...props} />;
        return <CreditCardIconOutline {...props} />;
      case "exclamation-circle":
        if (iconStyle === "solid")
          return <ExclamationCircleIconSolid {...props} />;
        if (iconStyle === "mini")
          return <ExclamationCircleIconMini {...props} />;
        if (iconStyle === "micro")
          return <ExclamationCircleIconMicro {...props} />;
        return <ExclamationCircleIconOutline {...props} />;
      case "exclamation-triangle":
        if (iconStyle === "solid")
          return <ExclamationTriangleIconSolid {...props} />;
        if (iconStyle === "mini")
          return <ExclamationTriangleIconMini {...props} />;
        if (iconStyle === "micro")
          return <ExclamationTriangleIconMicro {...props} />;
        return <ExclamationTriangleIconOutline {...props} />;
      case "qr-code":
        if (iconStyle === "solid") return <QrCodeIconSolid {...props} />;
        if (iconStyle === "mini") return <QrCodeIconMini {...props} />;
        if (iconStyle === "micro") return <QrCodeIconMicro {...props} />;
        return <QrCodeIconOutline {...props} />;
      case "banknotes":
        if (iconStyle === "solid") return <BanknotesIconSolid {...props} />;
        if (iconStyle === "mini") return <BanknotesIconMini {...props} />;
        if (iconStyle === "micro") return <BanknotesIconMicro {...props} />;
        return <BanknotesIconOutline {...props} />;
      case "chevron-down":
        if (iconStyle === "solid") return <ChevronDownIconSolid {...props} />;
        if (iconStyle === "mini") return <ChevronDownIconMini {...props} />;
        if (iconStyle === "micro") return <ChevronDownIconMicro {...props} />;
        return <ChevronDownIconOutline {...props} />;
      case "square-2-stack":
        if (iconStyle === "solid") return <Square2StackIconSolid {...props} />;
        if (iconStyle === "mini") return <Square2StackIconMini {...props} />;
        if (iconStyle === "micro") return <Square2StackIconMicro {...props} />;
        return <Square2StackIconOutline {...props} />;
      case "home":
        if (iconStyle === "solid") return <HomeIconSolid {...props} />;
        if (iconStyle === "mini") return <HomeIconMini {...props} />;
        if (iconStyle === "micro") return <HomeIconMicro {...props} />;
        return <HomeIconOutline {...props} />;
      case "building-office":
        if (iconStyle === "solid")
          return <BuildingOfficeIconSolid {...props} />;
        if (iconStyle === "mini") return <BuildingOfficeIconMini {...props} />;
        if (iconStyle === "micro")
          return <BuildingOfficeIconMicro {...props} />;
        return <BuildingOfficeIconOutline {...props} />;
      case "user":
        if (iconStyle === "solid") return <UserIconSolid {...props} />;
        if (iconStyle === "mini") return <UserIconMini {...props} />;
        if (iconStyle === "micro") return <UserIconMicro {...props} />;
        return <UserIconOutline {...props} />;
    }
  };

  return renderIcon();
};
